import React from "react";

const Skils = () => {
  return (
    <div className="px-10 py-10">
      <div className="hero min-h-25% text-white">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center justify-center ">
          <div data-aos="zoom-in-up" data-aos-duration="5000" data-aos-delay="2" className="max-w-sm mx-auto">
            <h2 className="text-xl mb-4">See my All Skill.</h2>
            <h2 className="text-4xl font-bold mb-4">My Working Skill</h2>

            <p >
              We provide company and finance service for startups and company
              business.
            </p>
          </div>
          <div data-aos="zoom-in-down" data-aos-duration="6000" className="grid grid-row-5 gap-6 my-10 px-6">
              <label>HTML</label>
            <progress
            
              className="progress progress-secondary w-4/5"
              value="90"
              max="100"
            ></progress>
            <label>CSS3</label>
            <progress
              className="progress progress-secondary w-4/5"
              value="90"
              max="100"
            ></progress>
            <label>React.js</label>
            <progress
              className="progress progress-secondary w-4/5"
              value="80"
              max="100"
            ></progress>
            <label>Node.js,Express.js</label>
            <progress
              className="progress progress-secondary w-4/5"
              value="70"
              max="100"
            ></progress>
            <label>MongoDB</label>
            <progress
              className="progress progress-secondary w-4/5"
              value="75"
              max="100"
            ></progress>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skils;
